// Parse a safe in-app return path from a route's query string.
//
// frontend-v3 launches the form editor with `?next=<url-encoded path>` so the
// create wizard can resume after save & close. We only ever accept a path on
// our own origin: it must start with a single '/' (rejecting protocol-relative
// '//evil.com', backslash tricks like '/\evil.com', and absolute scheme/host
// URLs) so it can't be turned into an open redirect — the editor always
// prepends its own configured origin. Returns '' when `next` is absent or
// unsafe, so callers fall back to the hardcoded return URL.
//
// Contract: the launching app MUST URL-encode the `next` value. The path
// carries its own nested query (e.g. `/forms/create/popup/behaviour?form=x`);
// URLSearchParams treats an unencoded `&` as a param separator, so an unencoded
// multi-param query would be truncated at the first `&` (a single `?param` value
// happens to survive). An encoded value round-trips intact — see the tests.

const SAFE_PATH = /^\/(?![/\\])/

export const isSafeReturnPath = (path) =>
  typeof path === 'string' && SAFE_PATH.test(path)

export const parseReturnUrl = (search) => {
  if (!search) {
    return ''
  }
  let next
  try {
    next = new URLSearchParams(search).get('next')
  } catch (e) {
    return ''
  }
  return isSafeReturnPath(next) ? next : ''
}
